<div style="width: 100%; padding-bottom: 30px">
  <app-view-instructions></app-view-instructions>
  <app-create-edit-instructions></app-create-edit-instructions>
</div>
